import React, { useEffect, useState } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { TabContainerProps } from "./TabContainer.props";
import styles from "./TabContainer.module.scss";

import Tab from "../Tab";

/**
 * @deprecated Use `import { TabbedContainer } from capitalrx-components-2.0/lib/general` instead.
 */
const TabContainer: React.FC<TabContainerProps> = (props: TabContainerProps) => {
  const { id, className, tabClassName, tabs, isLoading = false, size } = props;

  const tabContainerClasses = cn(
    styles["tab-container"], // static class for css
    className,
  );

  // if there is active tab in url query params - set it on page load
  const [activeIdx, setActiveIdx] = useState(0);
  useEffect(() => {
    if (props?.activeTabId) {
      setActiveIdx(props?.activeTabId);
    }
  }, []);

  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, idx: number): void => {
    e.preventDefault();
    setActiveIdx(idx);

    const { onClick } = tabs[idx];
    onClick && onClick(e);
  };

  // Logic for tab container structure
  return (
    <div className="tabs-content-container">
      <div id={id} data-testid={`test__${id}`} className={tabContainerClasses}>
        {tabs.map((tabObject, i) => {
          return (
            <Tab
              id={`${id}-tab-${i}`}
              key={`tab-${i}`}
              className={tabClassName}
              title={tabObject.title}
              isActive={i === activeIdx}
              isLoading={isLoading}
              disabled={tabs[i].disabled || undefined}
              size={size}
              onClick={(ev): void => handleOnClick(ev, i)}
            />
          );
        })}
      </div>
      <div
        id={id ? `content-${id}-${activeIdx}` : undefined}
        data-testid={id ? `test__content-${id}-${activeIdx}` : undefined}
        className="tab-content"
      >
        {!isLoading ? tabs[activeIdx].content : <Skeleton />}
      </div>
    </div>
  );
};

/**
 * @deprecated
 */
export default TabContainer;
